export const user_data_get_request = 'user_data_get_request'
export const user_data_get_success = 'user_data_get_success'
export const user_data_get_failure = 'user_data_get_failure'
